import PropTypes from 'prop-types';

export default PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string,
});
